import Map from './LocationInput';

export default Map;
